import { render, staticRenderFns } from "./EditIngredientNameDialog.vue?vue&type=template&id=0eb2da09&"
import script from "./EditIngredientNameDialog.vue?vue&type=script&lang=js&"
export * from "./EditIngredientNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports